import AboutUsSection from './sections/about-us/AboutUsSection'

function AboutUs() {

  return (
    <div className="App">
      <AboutUsSection />
    </div>
  )
}

export default AboutUs
